import React, { useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

export const Dashboard: React.FC = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  if (!user || user.links.length === 0) {
    return <div>No hay dashboards disponibles para su rol.</div>;
  }

  const currentLink = user.links[activeTab];

  return (
    <div className="flex flex-col h-full space-y-6 animate-fade-in">
      <header>
        <h1 className="text-3xl font-bold text-gray-900 tracking-tight">Dashboard</h1>
        <p className="text-gray-500 mt-1">Visualización de indicadores y métricas en tiempo real</p>
      </header>

      {/* Tabs */}
      {user.links.length > 1 && (
        <div className="flex gap-2 p-1 bg-gray-100/80 rounded-xl w-fit">
          {user.links.map((link, index) => (
            <button
              key={link.label}
              onClick={() => {
                setActiveTab(index);
                setIsLoading(true);
              }}
              className={cn(
                "px-6 py-2 rounded-lg text-sm font-medium transition-all",
                activeTab === index
                  ? "bg-white text-[#80142D] shadow-sm"
                  : "text-gray-500 hover:text-gray-700 hover:bg-white/50"
              )}
            >
              {link.label}
            </button>
          ))}
        </div>
      )}

      {/* Iframe Container */}
      <div className="flex-1 bg-white rounded-3xl overflow-hidden shadow-xl border border-gray-100 relative">
        {isLoading && (
          <div className="absolute inset-0 bg-white/80 backdrop-blur-sm z-10 flex flex-col items-center justify-center">
            <Loader2 className="w-10 h-10 text-[#80142D] animate-spin mb-4" />
            <p className="text-lg font-medium text-gray-700">Cargando datos...</p>
          </div>
        )}
        <iframe
          title={currentLink.label}
          className="w-full h-full border-none"
          src={currentLink.url}
          onLoad={() => setIsLoading(false)}
          allowFullScreen={true}
        ></iframe>
      </div>
    </div>
  );
};

export default Dashboard;
